import React, { Component } from 'react'
import './index.css'
import IconClose from '../IconClose';
import { STATUS_OPTION_HEX_PALLETE, statusOptions } from '../../constants';
import { Tooltip } from '@mui/material';


const colorFloatClass = (color) => "LucketStatusIcon statusfloat-" + color;
class LucketStatusIcon extends Component {

    state = {
        edit: false
    }

    edit = () => {
        if (this.state.edit === false) {
            this.setState({ edit: true })
        } else {
            this.setState({ edit: false })
        }

    }

    set = async (event, v) => {
        event.stopPropagation();
        this.setState({ edit: false })
        this.props.updateLucket(v, this.props.difficulty ? "difficulty" : "status", this.props.childLucket && this.props.lucket, this.props.childLucketIndex);

    }

    render() {
        if (this.props.isExpanded) {
            return <div>
                <Tooltip title={this.props.difficulty ? "Difficulty" : "Status"} placement='top'>
                    <div className="lucketStatusExpanded" style={{ backgroundColor: STATUS_OPTION_HEX_PALLETE[this.props.status] }} onClick={this.edit} />
                </Tooltip>
                {this.state.edit && <div style={{ textAlign: "left" }}>
                    <h3>Edit Status</h3>
                    <div className="StatusIconMenuExpanded">
                        {statusOptions.filter(
                            o => o !== this.props.lucket.status
                        ).map(o =>
                            <div key={"LucketStatusIconShort" + o} style={{ backgroundColor: STATUS_OPTION_HEX_PALLETE[o] }} className={'LucketStatusIconShort ' + 'statusfloat'}
                                onClick={(e) => this.set(e, o)} />
                        )}
                        <IconClose edit={this.edit} key={"close"} />
                    </div>  </div>}
            </div>

        }
        return (<Tooltip title={this.props.difficulty ? "Difficulty" : "Status"} placement='top'>
            <div id={"status" + this.props.lucket.rowID}
                className='lucketStatusIcon'
                style={{
                    backgroundColor: STATUS_OPTION_HEX_PALLETE[this.props.status],
                    borderRadius: this.props.difficulty ? '0px 0px 0px 0px' : '4px 0px 0px 4px',
                    borderLeftWidth: "1px",
                    borderRightColor: "lightgrey",
                    borderTopColor: "lightgrey",
                    borderBottomColor: "lightgrey",
                    borderRightWidth: "1px",
                    borderTopWidth: "1px",
                    borderBottomWidth: "1px",
                    borderLeftColor: "lightgrey",
                    borderStyle: "solid",
                    maxWidth: "16px",
                    minWidth: "16px",
                }}
                onClick={this.edit}>
                {(this.state.edit === true) ?
                    <div className="StatusIconEditorWrapper">
                        <div className="StatusIconCallout" />
                        <div id="menu" className="StatusIconMenu">
                            {statusOptions.filter(
                                o => o !== this.props.lucket.status
                            ).map(o =>
                                <div key={"LucketStatusIconShort" + o} style={{ backgroundColor: STATUS_OPTION_HEX_PALLETE[o] }} className={'LucketStatusIconShort ' + 'statusfloat'}
                                    onClick={(e) => this.set(e, o)} />
                            )}
                            <IconClose edit={this.edit} key={"close"} />
                        </div></div> : null}
            </div></Tooltip>)
    }

}

export default LucketStatusIcon